module.exports = __webpack_public_path__ + "static/media/Lights.cf360c37.logo";